import React, { useEffect, useState } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation } from 'swiper'
import { SwiperButton } from '../SwiperSlideButtons'
import { ChevronLeft, ChevronRight } from 'lucide-react'

const KEY_ESC = 27

const GalleryAllScreen = ({ items, onClose }) => {
  const [swiperMain, setSwiperMain] = useState(undefined)
  const [swiperThumb, setSwiperThumb] = useState(undefined)

  const onSwiperMainChange = () => {
    if (!swiperMain || !swiperThumb) return

    const activeIndex = swiperMain.activeIndex

    swiperThumb.slideTo(activeIndex)
  }

  const onSwiperThumbChange = () => {
    if (!swiperMain || !swiperThumb) return

    const activeIndex = swiperThumb.activeIndex

    swiperMain.slideTo(activeIndex)
  }

  const updateSlideByThumb = (index) => {
    if (!swiperMain || !swiperThumb) return

    const clickedIndex = index

    swiperMain.slideTo(clickedIndex)
    swiperThumb.slideTo(clickedIndex)
  }

  useEffect(() => {
    addEventListener('keyup', (e) => {
      if (e.keyCode == KEY_ESC) {
        onClose()
      }
    })
  }, [])

  return (
    <div className="gallery-all-screen">
      <div className="gallery-all-screen__modal-overlay">
        <div className="gallery-all-screen__container">
          <span className="gallery-all-screen__close" onClick={onClose} />
        </div>

        <div className="gallery-all-screen__main">
          <SwiperButton id="gallery-all-screen__prev-button">
            <ChevronLeft strokeWidth={2} color={'#000000'} />
          </SwiperButton>
          <Swiper
            centerInsufficientSlide={true}
            centeredSlides={true}
            className="swiper-container"
            grabCursor={true}
            preventClicks={true}
            initialSlide={Math.floor(items.length / 2) - 1}
            loop={false}
            modules={[Navigation]}
            navigation={{
              disabledClass: 'swiper-button--disabled',
              nextEl: '#gallery-all-screen__next-button',
              prevEl: '#gallery-all-screen__prev-button',
            }}
            onSwiper={setSwiperMain}
            onSlideChange={() => onSwiperMainChange()}
            slidesPerView={1}
            spaceBetween={24}
          >
            {items.map((item, index) => (
              <SwiperSlide key={index} className="swiper-slide-container">
                <div
                  className="gallery-all-screen__image"
                  style={{
                    backgroundImage: `url(${item.image.url})`,
                  }}
                ></div>
              </SwiperSlide>
            ))}
          </Swiper>
          <SwiperButton id="gallery-all-screen__next-button">
            <ChevronRight strokeWidth={2} color={'#000000'} />
          </SwiperButton>
        </div>

        <div className="gallery-all-screen__thumbs">
          <Swiper
            centerInsufficientSlides={true}
            centeredSlides={true}
            className="swiper-container"
            grabCursor={true}
            initialSlide={Math.floor(items.length / 2) - 1}
            loop={false}
            onSwiper={setSwiperThumb}
            onSlideChange={() => onSwiperThumbChange()}
            slidesPerView="auto"
            spaceBetween={24}
          >
            {items.map((item, index) => (
              <SwiperSlide
                key={index}
                className="swiper-slide-container"
                onClick={() => updateSlideByThumb(index)}
              >
                <div
                  className="gallery-all-screen__image-thumb"
                  style={{
                    backgroundImage: `url(${item.image.thumb.url})`,
                  }}
                ></div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </div>
  )
}

export default GalleryAllScreen
